import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Select from "../../../../components/Select";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";

export default function TechArea() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [techAreaList, setTechAreaList] = useState([]);
  const [techRoleList, setTechRoleList] = useState([]);

  useEffect(() => {
    getTechAreas();
  }, []);

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
        setTechAreaList(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
        setTechRoleList(data);
    });
  }

  useEffect(() => {
    if (searchObject?.techAreaId)
      getTechRoles(searchObject.techAreaId);
  }, [searchObject?.techAreaId]);
  
  return (
    <fieldset>
      <legend>{t("Tech Area / Tech Role")}</legend>
        <div className="col mb-2">
            <label className="form-label">{t("Tech Area")}</label>
            <Select
                className="form-select fontsize-legend"
                name="techAreaId"
                id="techAreaId"
                onChange={onChange}
                value={searchObject.techAreaId || ""}
            >
                <option></option>
                {techAreaList?.map((techArea) => (
                <option className="fontsize-legend" key={techArea.id} value={techArea.id}>
                    {t(techArea.description)}
                </option>
                ))}
            </Select>
        </div>
        <div className="col" style={{marginTop:"20px"}}>
          <label className="form-label">{t("Tech Role")}</label>
            <Select
            className="form-select fontsize-legend"
            name="techRoleId"
            id="techRoleId"
            onChange={onChange}
            value={searchObject.techRoleId || ""}
            >
            <option></option>
            {techRoleList?.map((techRole) => (
                <option className="fontsize-legend" key={techRole.id} value={techRole.id}>
                {t(techRole.description)}
                </option>
            ))}
            </Select>
        </div>
    </fieldset>
  );
}
